import { useState } from "react";
import { Text, TextInputProps } from "react-native";
import { useLocalSearchParams, useRouter } from "expo-router";
import {
  Form,
  Input,
  Label
} from "@/app/(auth)/login";
import { clearAuthError, setAuthError } from "@/_reducers/accounts.reducer";
import { useConfirmResetPasswordMutation } from "@/_store/auth/auth.slice";
import { useAppDispatch } from "@/_hooks";
import InfoAlert from "@/app/components/InfoAlert";
import { AlertWrapper } from "@/app/(auth)/reset-password";
import styled from "styled-components/native";
import CustomButton from "@/app/components/CustomButton";
import Container from "@/app/components/Container";
import useFocus from "@/_hooks/useFocus";
import { usePlatformStyles } from "@/_hooks/usePlatformStyles";

interface FormData {
  token: string;
  new_password: string;
  new_password_confirm: string;
}

const Confirm = () => {
  const { token } = useLocalSearchParams();
  const router = useRouter();
  const tokenConfirm: string = Array.isArray(token) ? token[0] : token ?? "";

  const dispatch = useAppDispatch();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [passwordConfirm, setPasswordConfirm] = useState<string>("");

  const passwordFocus = useFocus();
  const repeatPasswordFocus = useFocus();
  const { webOutlineNone } = usePlatformStyles();
  const [confirmResetPassword, { isLoading }] = useConfirmResetPasswordMutation()

  const handleConfirmPassword = async (): Promise<void> => {
    try {
      const formData: FormData = {
        token: tokenConfirm,
        new_password: password,
        new_password_confirm :passwordConfirm,
      };

      await confirmResetPassword(formData).unwrap();
      dispatch(clearAuthError())
      setIsSubmitted(true)
    } catch (err: any) {
      console.error(err);
      dispatch(setAuthError(err))
    }
  }

  if (isSubmitted) {
    return (
      <Container>
        <Text className="text-header">Восстановление пароля</Text>
        <AlertWrapper>
          <InfoAlert
            textInfo={
              "Новый пароль установлен. Теперь вы можете войти, используя новые данные."
            }
          />
        </AlertWrapper>
        <CustomButton
          className="mb-4"
          type="primary"
          title="К авторизации"
          onPress={() => router.push("/login")}
          disabled={isLoading}
        />
      </Container>
    );
  }

  const inputCommonProps: TextInputProps = {
    placeholderTextColor: "#9FABBE",
    autoCapitalize: "none",
    keyboardType: "default",
    underlineColorAndroid: "transparent",
  };

  return(
    <Container>
      <Text className="text-header">Восстановление пароля</Text>
      <Text className="text-subhead">Пожалуйста, введите новый пароль.</Text>
      <WrapperAlert>
        <InfoAlert
          textInfo={
            "Пароль должен содержать не менее 6 символов: латинские буквы верхнего и нижнего регистра и цифры."
          }
        />
      </WrapperAlert>
      <Form>
        <Label>Придумайте пароль</Label>
        <Input
          placeholder="Введите пароль"
          onFocus={passwordFocus.onFocus}
          isFocused={passwordFocus.isFocused}
          onBlur={passwordFocus.onBlur}
          value={password}
          onChangeText={setPassword}
          style={webOutlineNone}
          {...inputCommonProps}
        />
        <Label>Повторите пароль</Label>
        <Input
          placeholder="Введите пароль"
          value={passwordConfirm}
          onChangeText={setPasswordConfirm}
          style={webOutlineNone}
          isFocused={repeatPasswordFocus.isFocused}
          onFocus={repeatPasswordFocus.onFocus}
          onBlur={repeatPasswordFocus.onBlur}
          {...inputCommonProps}
        />
        <CustomButton
          title="Подтвердить"
          type="primary"
          onPress={handleConfirmPassword}
          disabled={isLoading}
        />
      </Form>
    </Container>
  );
};

export default Confirm;

export const WrapperAlert = styled.View`
  margin-bottom: 24px;
`;
